import React from 'react';
import { Page } from '../../components/Page/Page';
import { ExternalLink } from '~components/ExternalLink/ExternalLink';
import { SubTitle } from '~components/SubTitle/SubTitle';

export const ArtNeoTraditionalPage = () => {
	return (
		<Page backLink="/art" title="Neo Traditional">
			<p>
				The neo traditional style combines elements of both traditional and
				modern tattoo designs, often featuring bold lines, vibrant colors, and a
				mix of familiar and unique subject matter.
			</p>
			<ExternalLink
				link="https://certifiedtattoo.com/neo-traditional-tattoos"
				title="certifiedtattoo.com"
			/>

			<p>
				This unique tattoo style is a fusion of the past and present, offering a
				fresh take on traditional designs that still pay homage to classic
				tattooing techniques.
			</p>
			<p>
				With their intricate symbolism, bold lines, and vibrant colors,
				it&apos;s no wonder Neo traditional tattoos are such a popular choice
				for those looking for a unique and expressive tattoo.
			</p>
			<p>
				These tattoos are not only a work of art but also tell a story of our
				past, present, and future
			</p>
			<p>
				Neo Traditional tattoos are a modern take on the classic traditional
				tattoo design style. They emerged in the 80s and 90s when tattoo artists
				began to mix traditional designs with new-school techniques, creating a
				unique style that incorporated the best of both worlds.
			</p>
			<p>
				The designs typically feature bold lines, vibrant colors, and intricate
				details that incorporate various symbols and images.
			</p>
			<p>
				The bold lines, vibrant colors, and intricate designs make Neo
				Traditional art immediately recognizable and visually appealing.
			</p>
			<img src="https://images.squarespace-cdn.com/content/v1/61f6f914388acb6c7aaf8d6f/a0a6f44e-b2ae-442f-a862-fb69af72998a/Certified+Tattoo+Studios+-+Neo-traditional+tattoo-4.jpg" />
			<ExternalLink
				link="https://certifiedtattoo.com/blog/what-does-neo-traditional-mean-appreciating-timeless-artifacts-of-history"
				title="certifiedtattoo.com"
			/>

			<SubTitle>What are the rules to neo traditional?</SubTitle>
			<p>
				Neo-traditional is a tattoo style that combines elements of traditional
				tattooing with contemporary influences. While the rules of neo
				traditional tattooing are not rigidly defined, there are some common
				characteristics that can be observed:
			</p>
			<ol>
				<li>
					Bold Outlines: Neo traditional tattoos typically feature bold, clean
					outlines that define the design and give it a distinct and
					recognizable appearance.
				</li>
				<li>
					Limited Color Palette: The color palette used in neo-traditional
					tattoos is often more vibrant and varied compared to traditional
					tattoos. However, it is still typically limited to a specific range of
					colors, often with a preference for rich and saturated tones.
				</li>
				<li>
					Symbolic Imagery: Neo traditional tattoos often incorporate
					traditional tattoo motifs such as animals, flowers, skulls, hearts,
					and other classic designs. These elements are often rendered in a more
					stylized and illustrative manner, with added depth, shading, and
					detail.
				</li>
				<li>
					High Contrast: A key characteristic of neo traditional tattoos is the
					use of high contrast. This involves a strong interplay between light
					and dark areas within the design, achieved through shading, stippling,
					and color saturation. This technique adds dimension and visual impact
					to the tattoo.
				</li>
				<li>
					Artistic Freedom: One of the defining aspects of neo-traditional
					tattooing is the freedom for artists to reinterpret traditional
					designs and incorporate their own artistic flair. This allows for
					greater creativity, innovation, and personalization within the style.
				</li>
			</ol>
			<ExternalLink
				link="https://certifiedtattoo.com/blog/what-does-neo-traditional-mean-appreciating-timeless-artifacts-of-history"
				title="certifiedtattoo.com"
			/>

			<SubTitle>Neo Meaning</SubTitle>
			<p>
				A combining form meaning “new”, “recent”, “revived”, “modified,”. used
				in the formation of compound words.
			</p>
			<ExternalLink
				link="https://www.dictionary.com/browse/neo"
				title="dictionary.com"
			/>
		</Page>
	);
};
